// @ts-nocheck
import { apiFetchInit, LS_ROLE } from "@/legacy/helpersModule";
import { TalentPoolSubmit } from "@/features/talent-pool/components/TalentPoolSubmit";
import { useAppState } from "@/app/state/AppStateProvider";
import { useToast } from "@/shared/components/ui";

export function TalentPoolPage() {
  const {
    active,
    authCandidate,
    maxCvMb,
    cmCooling,
    navigate,
    tpFromPortal,
    tpGuestEntryRef,
    setTpGuestRegPrefill,
    setRegisterPhase,
    setTalentPool,
  } = useAppState();
  const toast = useToast();

  return (
    <TalentPoolSubmit
      candidate={active}
      guestMode={!authCandidate}
      maxCvMb={maxCvMb}
      coolingMonths={cmCooling}
      onSubmit={async (entry) => {
        try {
          const res = await fetch(
            "/api/talent-pool",
            apiFetchInit({
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(entry),
            }),
          );
          const data = await res.json().catch(() => ({}));
          if (!res.ok) {
            toast.show({
              tone: "danger",
              title: "Submission failed",
              message: data.error || "Could not submit to talent pool.",
              durationMs: 6000,
            });
            return false;
          }
          const saved = { ...entry, id: data.id || entry.id };
          if (localStorage.getItem(LS_ROLE) === "hr") {
            setTalentPool((p) => [...p, saved]);
          }
          return true;
        } catch (e) {
          toast.show({
            tone: "danger",
            title: "Network error",
            message: "Could not reach server.",
            durationMs: 6000,
          });
          return false;
        }
      }}
      onGuestContinue={(entry) => {
        tpGuestEntryRef.current = entry;
        setTpGuestRegPrefill({ name: entry.name, email: entry.email });
        setRegisterPhase("consent");
        navigate("/register");
      }}
      onBack={() => {
        tpGuestEntryRef.current = null;
        setTpGuestRegPrefill(null);
        if (tpFromPortal) navigate("/portal");
        else navigate("/");
      }}
    />
  );
}

export function TalentPoolDonePage() {
  const { navigate } = useAppState();
  return (
    <div className="min-h-dvh safe-bottom bg-slate-50 flex flex-col items-center justify-center p-4 sm:p-8 text-center">
      <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6 text-3xl">
        ✓
      </div>
      <h1 className="text-xl sm:text-3xl font-black text-slate-900 mb-2">Added to Talent Pool</h1>
      <p className="text-slate-500 mb-5 max-w-md">
        HR SPOCs will reach out when a matching role opens.
      </p>
      <button
        type="button"
        onClick={() => navigate("/")}
        className="bg-slate-900 text-white px-8 py-3 rounded-xl font-bold"
      >
        Done
      </button>
    </div>
  );
}
